(()=>{/* 誉展示会 quote integration.
 * Uploaded item dimensions and labels retained.
 * Saved state formats are accepted; the shared decoder migrates legacy bridge sides and preserves individual poses.
 * Form, snapshot validation, totals and contact submission remain unchanged.
 */
const Ln = [
  {
    "id": "1",
    "label": "1小間",
    "w": 3,
    "d": 3
  },
  {
    "id": "2",
    "label": "2小間",
    "w": 6,
    "d": 3
  },
  {
    "id": "3",
    "label": "3小間",
    "w": 9,
    "d": 3
  },
  {
    "id": "4",
    "label": "4小間",
    "w": 6,
    "d": 6
  },
  {
    "id": "5",
    "label": "5小間",
    "w": 15,
    "d": 3
  },
  {
    "id": "6",
    "label": "6小間",
    "w": 9,
    "d": 6
  },
  {
    "id": "shallow3",
    "label": "奥行2.7mタイプ・幅3m",
    "w": 3,
    "d": 2.7
  },
  {
    "id": "shallow6",
    "label": "奥行2.7mタイプ・幅6m",
    "w": 6,
    "d": 2.7
  }
];
const Ae = [
  {
    "id": "p300300",
    "group": "panel",
    "label": "背面バックパネル（幅3m × 高さ3m）",
    "short": "幅3m × 高さ3m",
    "size": "幅3m × 高さ3m",
    "w": 3,
    "h": 3,
    "d": 0.42,
    "handle": "sego-light-box-300-300"
  },
  {
    "id": "p300200",
    "group": "panel",
    "label": "背面バックパネル（幅3m × 高さ2m）",
    "short": "幅3m × 高さ2m",
    "size": "幅3m × 高さ2m",
    "w": 3,
    "h": 2,
    "d": 0.42,
    "handle": "sego-light-box-300-200"
  },
  {
    "id": "p100300",
    "group": "panel",
    "label": "背面バックパネル（幅1m × 高さ3m）",
    "short": "幅1m × 高さ3m",
    "size": "幅1m × 高さ3m",
    "w": 1,
    "h": 3,
    "d": 0.42,
    "handle": "sego-light-box-100-300"
  },
  {
    "id": "p100200",
    "group": "panel",
    "label": "背面バックパネル（幅1m × 高さ2m）",
    "short": "幅1m × 高さ2m",
    "size": "幅1m × 高さ2m",
    "w": 1,
    "h": 2,
    "d": 0.42,
    "handle": "sego-light-box-100-200"
  },
  {
    "id": "bridge",
    "group": "bridge",
    "label": "ブリッジ（高さ2m）",
    "short": "高さ2m",
    "size": "幅1m × 高さ2m／背面パネルに接続",
    "max": 3,
    "w": 1,
    "h": 2,
    "d": 2.24,
    "handle": "sego-light-box-bridge-set"
  },
  {
    "id": "bridge300",
    "group": "bridge",
    "label": "ブリッジ（高さ3m）",
    "short": "高さ3m",
    "size": "幅1m × 高さ3m／背面パネルに接続",
    "max": 3,
    "w": 1,
    "h": 3,
    "d": 2.24,
    "handle": "sego-light-box-bridge-set"
  },
  {
    "id": "side_l_100200",
    "group": "side-left",
    "label": "左面バックパネル（幅1m×高さ2m）",
    "short": "幅1m×高さ2m",
    "size": "幅1m×高さ2m",
    "max": 1,
    "w": 1,
    "h": 2,
    "d": 0.42,
    "productKey": "p100200",
    "handle": "sego-light-box-100-200"
  },
  {
    "id": "side_l_200200",
    "group": "side-left",
    "label": "左面バックパネル（幅2m×高さ2m）",
    "short": "幅2m×高さ2m",
    "size": "幅2m×高さ2m",
    "max": 1,
    "w": 2,
    "h": 2,
    "d": 0.42,
    "productKey": "p200200",
    "handle": "sego-light-box-200-200"
  },
  {
    "id": "side_l_300200",
    "group": "side-left",
    "label": "左面バックパネル（幅3m×高さ2m）",
    "short": "幅3m×高さ2m",
    "size": "幅3m×高さ2m",
    "max": 1,
    "w": 3,
    "h": 2,
    "d": 0.42,
    "productKey": "p300200",
    "handle": "sego-light-box-300-200"
  },
  {
    "id": "side_l_100300",
    "group": "side-left",
    "label": "左面バックパネル（幅1m×高さ3m）",
    "short": "幅1m×高さ3m",
    "size": "幅1m×高さ3m",
    "max": 1,
    "w": 1,
    "h": 3,
    "d": 0.42,
    "productKey": "p100300",
    "handle": "sego-light-box-100-300"
  },
  {
    "id": "side_l_200300",
    "group": "side-left",
    "label": "左面バックパネル（幅2m×高さ3m）",
    "short": "幅2m×高さ3m",
    "size": "幅2m×高さ3m",
    "max": 1,
    "w": 2,
    "h": 3,
    "d": 0.42,
    "productKey": "p200300",
    "handle": "sego-light-box-200-300"
  },
  {
    "id": "side_l_300300",
    "group": "side-left",
    "label": "左面バックパネル（幅3m×高さ3m）",
    "short": "幅3m×高さ3m",
    "size": "幅3m×高さ3m",
    "max": 1,
    "w": 3,
    "h": 3,
    "d": 0.42,
    "productKey": "p300300",
    "handle": "sego-light-box-300-300"
  },
  {
    "id": "side_r_100200",
    "group": "side-right",
    "label": "右面バックパネル（幅1m×高さ2m）",
    "short": "幅1m×高さ2m",
    "size": "幅1m×高さ2m",
    "max": 1,
    "w": 1,
    "h": 2,
    "d": 0.42,
    "productKey": "p100200",
    "handle": "sego-light-box-100-200"
  },
  {
    "id": "side_r_200200",
    "group": "side-right",
    "label": "右面バックパネル（幅2m×高さ2m）",
    "short": "幅2m×高さ2m",
    "size": "幅2m×高さ2m",
    "max": 1,
    "w": 2,
    "h": 2,
    "d": 0.42,
    "productKey": "p200200",
    "handle": "sego-light-box-200-200"
  },
  {
    "id": "side_r_300200",
    "group": "side-right",
    "label": "右面バックパネル（幅3m×高さ2m）",
    "short": "幅3m×高さ2m",
    "size": "幅3m×高さ2m",
    "max": 1,
    "w": 3,
    "h": 2,
    "d": 0.42,
    "productKey": "p300200",
    "handle": "sego-light-box-300-200"
  },
  {
    "id": "side_r_100300",
    "group": "side-right",
    "label": "右面バックパネル（幅1m×高さ3m）",
    "short": "幅1m×高さ3m",
    "size": "幅1m×高さ3m",
    "max": 1,
    "w": 1,
    "h": 3,
    "d": 0.42,
    "productKey": "p100300",
    "handle": "sego-light-box-100-300"
  },
  {
    "id": "side_r_200300",
    "group": "side-right",
    "label": "右面バックパネル（幅2m×高さ3m）",
    "short": "幅2m×高さ3m",
    "size": "幅2m×高さ3m",
    "max": 1,
    "w": 2,
    "h": 3,
    "d": 0.42,
    "productKey": "p200300",
    "handle": "sego-light-box-200-300"
  },
  {
    "id": "side_r_300300",
    "group": "side-right",
    "label": "右面バックパネル（幅3m×高さ3m）",
    "short": "幅3m×高さ3m",
    "size": "幅3m×高さ3m",
    "max": 1,
    "w": 3,
    "h": 3,
    "d": 0.42,
    "productKey": "p300300",
    "handle": "sego-light-box-300-300"
  },
  {
    "id": "counter",
    "group": "counter",
    "label": "セゴ100x100",
    "size": "本体 幅1m × 高さ1m",
    "max": 3,
    "w": 1.04,
    "h": 1.02,
    "d": 0.42,
    "handle": "sego-light-box-top-panel"
  },
  {
    "id": "meeting",
    "group": "counter",
    "label": "カクテルカウンター",
    "size": "直径0.8m × 高さ1.1m",
    "max": 3,
    "w": 0.8,
    "h": 1.1,
    "d": 0.8,
    "handle": "cocktail-table"
  },
  {
    "id": "counter50",
    "group": "counter",
    "label": "セゴカウンター50x100",
    "size": "W520mm × D520mm × H1020mm",
    "max": 3,
    "w": 0.52,
    "h": 1.02,
    "d": 0.52,
    "handle": "sego-light-box-100-50-counter"
  },
  {
    "id": "backyard",
    "group": "backyard",
    "label": "バックヤード（高さ2.25m）",
    "short": "高さ2.25m",
    "size": "高さ2.25m／背面パネルに対して縦向き",
    "max": 1,
    "w": 1,
    "h": 2.25,
    "d": 2,
    "handle": "sego-light-box-backyard-set"
  },
  {
    "id": "backyard300",
    "group": "backyard",
    "label": "バックヤード（高さ3m）",
    "short": "高さ3m",
    "size": "高さ3m／背面パネルに対して縦向き",
    "max": 1,
    "w": 1,
    "h": 3,
    "d": 2,
    "handle": "sego-light-box-backyard-set"
  },
  {
    "id": "monitor",
    "group": "monitor",
    "label": "モニターテーブルスタンド",
    "size": "手前に配置／モニター・天板付き",
    "max": 3,
    "w": 0.9,
    "h": 2.2,
    "d": 0.65,
    "handle": "monitor-table-stand-fabric",
    "approximate": true
  },
  {
    "id": "rack",
    "group": "rack",
    "label": "ラック付ファブリックサイン",
    "size": "手前に配置／カタログラック2段",
    "max": 3,
    "w": 0.45,
    "h": 1.5,
    "d": 0.5,
    "handle": "fabric-sign-with-catalog-rack",
    "approximate": true
  },
  {
    "id": "showcase",
    "group": "showcase",
    "label": "ショーケース",
    "size": "Oval／幅0.6m × 高さ1.7m × 奥行0.4m",
    "max": 3,
    "w": 0.6,
    "h": 1.7,
    "d": 0.4,
    "handle": "promotion-showcase-fabric"
  }
];
const vo = [
  {
    "id": "panel",
    "label": "背面バックパネル",
    "mode": "multiple"
  },
  {
    "id": "bridge",
    "label": "ブリッジ",
    "mode": "multiple"
  },
  {
    "id": "side-left",
    "label": "左面バックパネル",
    "mode": "single"
  },
  {
    "id": "side-right",
    "label": "右面バックパネル",
    "mode": "single"
  },
  {
    "id": "counter",
    "label": "カウンター",
    "mode": "multiple"
  },
  {
    "id": "backyard",
    "label": "バックヤード",
    "mode": "single"
  },
  {
    "id": "monitor",
    "label": "モニターテーブルスタンド",
    "mode": "quantity"
  },
  {
    "id": "rack",
    "label": "ラック付ファブリックサイン",
    "mode": "quantity"
  },
  {
    "id": "showcase",
    "label": "ショーケース",
    "mode": "quantity"
  }
];
const vn = {
  "forest": {
    "name": "フォレスト",
    "base": "#245f58",
    "dark": "#174a44",
    "light": "#91b5a1",
    "pale": "#d1e0cf",
    "floor": "#dce3d9"
  },
  "navy": {
    "name": "ネイビー",
    "base": "#314d75",
    "dark": "#223a5d",
    "light": "#93aec8",
    "pale": "#d6e1e8",
    "floor": "#dce2e8"
  },
  "terracotta": {
    "name": "テラコッタ",
    "base": "#b7664c",
    "dark": "#874d3d",
    "light": "#d3ab85",
    "pale": "#ecd7c2",
    "floor": "#e6dfd5"
  },
  "charcoal": {
    "name": "チャコール",
    "base": "#53565a",
    "dark": "#383d42",
    "light": "#a9b1a9",
    "pale": "#dbe0d7",
    "floor": "#dedfdd"
  }
};
const BOOTH_LEGACY_IDS = [
  "p300300",
  "p300200",
  "p100300",
  "p100200",
  "counter",
  "meeting",
  "bridge",
  "backyard",
  "showcase"
];

const cr = layout => Math.round(layout.w * layout.d * 100) / 100;
const vi = layout => Math.ceil(cr(layout));
const nc = "奥行2.7mタイプの床装飾は面積換算の概算です。500mm角パネルの敷き方・必要部材は別途確認が必要です。";
const hr = [...Ae, {id:"floorea", label:"床装飾 フロリア（1㎡／商品）", max:Math.max(...Ln.map(vi)), handle:"floorea-booth-floor-panel"}];
const BOOTH_BRIDGE_SIDE_KEYS = ["bridgeRight","bridgeLeft","bridge300Right","bridge300Left"];
const yo = state => Object.fromEntries(hr.map(item => [item.id, item.id === "floorea" ? (state.floorEnabled ? vi(state.layout) : 0) : (state.counts[item.id] || 0)]));
const Mi = id => hr.find(item => item.id === id)?.max ?? 20;
const We = (id, value) => Number.isFinite(Number(value)) ? Math.max(0, Math.min(Mi(id), Math.round(Number(value)))) : 0;
const ec = item => ({w:item.w, h:item.h, d:item.d});
const BOOTH_EXCLUSIVE_GROUPS = ["side-left", "side-right", "backyard"];
function boothGroupItems(group) { return Ae.filter(item => item.group === group); }
function boothGroupCount(counts, group) { return boothGroupItems(group).reduce((sum,item) => sum + (counts[item.id] || 0), 0); }
const boothLegacyWe=(id,value)=>Math.min(id==="bridge"||id==="bridge300"?2:Mi(id),We(id,value));
function boothBridgeSideCounts(raw = {}) {
  return {
    bridgeRight: Math.max(0, Math.min(2, Math.round(Number(raw.bridgeRight) || 0))),
    bridgeLeft: Math.max(0, Math.min(2, Math.round(Number(raw.bridgeLeft) || 0))),
    bridge300Right: Math.max(0, Math.min(2, Math.round(Number(raw.bridge300Right) || 0))),
    bridge300Left: Math.max(0, Math.min(2, Math.round(Number(raw.bridge300Left) || 0)))
  };
}
function boothDeriveBridgeSideCounts(raw = {}) {
  const result = boothBridgeSideCounts();
  const distribute = (id, rightKey, leftKey) => {
    const total = Math.max(0, Math.min(2, boothLegacyWe(id, raw[id])));
    result[rightKey] = total > 0 ? 1 : 0;
    result[leftKey] = total > 1 ? 1 : 0;
  };
  distribute("bridge", "bridgeRight", "bridgeLeft");
  distribute("bridge300", "bridge300Right", "bridge300Left");
  return result;
}
function boothNormaliseLegacyCounts(raw = {}) {
  const result = Object.fromEntries(Ae.map(item => [item.id, boothLegacyWe(item.id, raw[item.id])]));
  const hasExplicitBridgeSides = BOOTH_BRIDGE_SIDE_KEYS.some(key => raw[key] != null);
  const bridgeSides = hasExplicitBridgeSides ? boothBridgeSideCounts(raw) : boothDeriveBridgeSideCounts(result);
  for (const [id, rightKey, leftKey] of [["bridge","bridgeRight","bridgeLeft"],["bridge300","bridge300Right","bridge300Left"]]) {
    let remaining = 2;
    result[rightKey] = Math.min(remaining, bridgeSides[rightKey]);
    remaining -= result[rightKey];
    result[leftKey] = Math.min(remaining, bridgeSides[leftKey]);
    result[id] = result[rightKey] + result[leftKey];
  }
  // Keep both heights and all explicit sides unchanged within the two-piece limit.
  // For malformed oversized input, retain one existing item on each occupied side first.
  if (result.bridge + result.bridge300 > 2) {
    const kept = boothBridgeSideCounts();
    let remaining = 2;
    for (const suffix of ["Right", "Left"]) {
      const key = ["bridge" + suffix, "bridge300" + suffix].find(key => result[key] > 0);
      if (key && remaining) { kept[key] = 1; remaining--; }
    }
    for (const key of BOOTH_BRIDGE_SIDE_KEYS) {
      const extra = Math.min(remaining, result[key] - kept[key]);
      kept[key] += extra; remaining -= extra;
    }
    Object.assign(result, kept);
    result.bridge = kept.bridgeRight + kept.bridgeLeft;
    result.bridge300 = kept.bridge300Right + kept.bridge300Left;
  }
  for (const group of BOOTH_EXCLUSIVE_GROUPS) {
    let used = false;
    for (const item of boothGroupItems(group)) {
      if (used) result[item.id] = 0;
      if (result[item.id]) used = true;
    }
  }
  let remaining = 3;
  for (const item of boothGroupItems("counter")) {
    result[item.id] = Math.min(remaining, result[item.id]);
    remaining -= result[item.id];
  }
  return result;
}
function boothDecodeLegacy(encoded) {
  if (typeof encoded !== "string" || encoded.length > 640) return null;
  const tokens = encoded.split("~"), version = tokens[0];
  const old = ["1","2","3"].includes(version);
  if (!old && !["4","5"].includes(version)) return null;
  const ids = old ? BOOTH_LEGACY_IDS : Ae.map(item => item.id);
  const floorIndex = ids.length + 3;
  const expected = version === "1" ? floorIndex : version === "2" ? floorIndex+1 : ["3","4"].includes(version) ? floorIndex+2 : floorIndex+6;
  if (tokens.length !== expected) return null;
  const layout = Ln.find(item => item.id === tokens[1]);
  if (!layout || !/^[0-3]$/.test(tokens[2])) return null;
  const color = Object.keys(vn)[Number(tokens[2])];
  const counts = Object.fromEntries(Ae.map(item => [item.id,0]));
  for (let index=0; index<ids.length; index++) {
    const value = tokens[index+3], id = ids[index];
    if (!/^\d{1,2}$/.test(value) || Number(value) > (id==="bridge"||id==="bridge300"?2:Mi(id))) return null;
    counts[id] = Number(value);
  }
  if (version !== "1" && !/^[01]$/.test(tokens[floorIndex])) return null;
  const floorVariantId = ["3","4","5"].includes(version) ? tokens[floorIndex+1] : "";
  if (!/^(?:[1-9]\d{0,19})?$/.test(floorVariantId)) return null;
  if (version === "5") {
    const extraKeys = BOOTH_BRIDGE_SIDE_KEYS;
    for (let i=0; i<extraKeys.length; i++) {
      const value = tokens[floorIndex+2+i];
      if (!/^\d$/.test(value) || Number(value) > 2) return null;
      counts[extraKeys[i]] = Number(value);
    }
  }
  const normalised = boothNormaliseLegacyCounts(counts);
  for (const item of Ae) if ((counts[item.id] || 0) !== normalised[item.id]) return null;
  if (version === "5" && BOOTH_BRIDGE_SIDE_KEYS.some(key => counts[key] !== normalised[key])) return null;
  return {layout, color, counts:normalised, shape:"oval", floorEnabled:version!=="1" && tokens[floorIndex]==="1", floorVariantId, legacyVersion:old ? Number(version) : null};
}


/* Count rules and compact instance state shared by simulator and quote. */
function boothNormaliseCounts(raw={}) {
  const result=Object.fromEntries(Ae.map(item=>[item.id,We(item.id,raw[item.id])]));
  result.bridge300=Math.min(result.bridge300,3-result.bridge);
  for(const group of BOOTH_EXCLUSIVE_GROUPS) {
    let used=false;
    for(const item of boothGroupItems(group)) {
      if(used)result[item.id]=0;
      if(result[item.id])used=true;
    }
  }
  return result;
}
const BOOTH_POSE_LIMIT=500;
const boothSpec=id=>Ae.find(item=>item.id===id);
const boothTurn=angle=>((Math.round(angle/(Math.PI/2))%4)+4)%4;
const boothRound=value=>Math.round(value*1000)/1000;
const boothYaw=record=>record.turn*Math.PI/2;
function boothLocal(record,x,z) {
  const a=boothYaw(record),c=Math.cos(a),s=Math.sin(a);
  return {x:record.x+c*x+s*z,z:record.z-s*x+c*z};
}
function boothRelative(record,point) {
  const a=boothYaw(record),c=Math.cos(a),s=Math.sin(a),x=point.x-record.x,z=point.z-record.z;
  return {x:c*x-s*z,z:s*x+c*z};
}
function boothPoseSlot(record) {
  return BOOTH_EXCLUSIVE_GROUPS.includes(boothSpec(record.id).group)?boothSpec(record.id).group:record.id+':'+record.ordinal;
}
function boothExpectedSlots(counts,legacy=false) {
  const result=[];
  for(const spec of Ae) {
    if(legacy&&spec.group==='bridge') {
      for(const side of ['right','left'])for(let ordinal=0;ordinal<(counts[spec.id+(side==='right'?'Right':'Left')]||0);ordinal++)result.push({id:spec.id,side,ordinal});
    } else for(let ordinal=0;ordinal<(counts[spec.id]||0);ordinal++)result.push({id:spec.id,side:'',ordinal});
  }
  return result;
}
function boothSupport(bridge,panels) {
  if(!panels.length)return false;
  const spec=boothSpec(bridge.id),intervals=[];
  for(const panel of panels) {
    if(!panel||boothSpec(panel.id)?.group!=='panel'||panel.turn!==bridge.turn)return false;
    const point=boothRelative(panel,bridge),ps=boothSpec(panel.id);
    if(Math.abs(point.z-(.0602+spec.d/2))>.004)return false;
    const relative=boothRelative(bridge,panel);
    intervals.push([relative.x-ps.w/2,relative.x+ps.w/2]);
  }
  intervals.sort((a,b)=>a[0]-b[0]);let edge=-spec.w/2;
  for(const [left,right] of intervals) {
    if(right<=edge+.004)continue;
    if(left>edge+.004)return false;
    edge=Math.max(edge,right);
  }
  return edge>=spec.w/2-.004;
}
function boothValidateInstances(instances,counts,legacy=false) {
  const expected=boothExpectedSlots(counts,legacy);
  if(!Array.isArray(instances)||instances.length!==expected.length||instances.length>112)return false;
  const ids=new Set(),slots=new Set();
  for(const item of instances) {
    const spec=boothSpec(item.id);
    if(!spec||!/^[1-9a-z][0-9a-z]{0,5}$/.test(item.uid||'')||parseInt(item.uid,36)>1e8||ids.has(item.uid)||
      !Number.isInteger(item.ordinal)||item.ordinal<0||item.ordinal>19||!Number.isInteger(item.turn)||item.turn<0||item.turn>3||
      !Number.isFinite(item.x)||!Number.isFinite(item.z)||Math.abs(item.x)>BOOTH_POSE_LIMIT||Math.abs(item.z)>BOOTH_POSE_LIMIT||
      !Array.isArray(item.parents)||item.parents.length>4||new Set(item.parents).size!==item.parents.length||
      (legacy&&spec.group==='bridge'?!['left','right'].includes(item.side):item.side!=='')||
      (spec.group!=='bridge'&&item.parents.length))return false;
    const slot=legacy&&spec.group==='bridge'?item.id+':'+item.side+':'+item.ordinal:boothPoseSlot(item);
    if(slots.has(slot)||!expected.some(e=>e.id===item.id&&e.ordinal===item.ordinal&&e.side===item.side))return false;
    ids.add(item.uid);slots.add(slot);
  }
  for(const item of instances)if(item.parents.length&&!boothSupport(item,item.parents.map(uid=>instances.find(record=>record.uid===uid))))return false;
  return true;
}
function boothEncodeState(state) {
  const counts=boothNormaliseCounts(state.counts),colorIndex=Object.keys(vn).indexOf(state.color);
  const records=state.instances?state.instances.map(item=>[
    item.uid,Ae.findIndex(spec=>spec.id===item.id).toString(36),item.ordinal.toString(36),'n',
    Math.round(item.x*1000).toString(36),Math.round(item.z*1000).toString(36),item.turn,item.parents.join('-')
  ].join('.')).join('_'):'*';
  if(state.instances&&!boothValidateInstances(state.instances,counts))throw new Error('配置データを保存できません。接続と座標を確認してください。');
  const encoded=['7',state.layout.id,colorIndex,...Ae.map(item=>counts[item.id]||0),state.floorEnabled?'1':'0',/^[1-9]\d{0,19}$/.test(state.floorVariantId||'')?state.floorVariantId:'',records].join('~');
  if(encoded.length>8192)throw new Error('配置データが保存可能な長さを超えています。');
  return encoded;
}
function boothParseRecords(payload) {
  const instances=[];
  if(payload)for(const raw of payload.split('_')) {
    const f=raw.split('.');
    if(f.length!==8||!/^[1-9a-z][0-9a-z]{0,5}$/.test(f[0])||!/^[0-9a-z]{1,2}$/.test(f[1])||!/^[0-9a-z]$/.test(f[2])||
      !['l','r','n'].includes(f[3])||!/^-?[0-9a-z]{1,5}$/.test(f[4])||!/^-?[0-9a-z]{1,5}$/.test(f[5])||!/^[0-3]$/.test(f[6]))return null;
    const spec=Ae[parseInt(f[1],36)];if(!spec)return null;
    instances.push({uid:f[0],id:spec.id,ordinal:parseInt(f[2],36),side:f[3]==='l'?'left':f[3]==='r'?'right':'',x:parseInt(f[4],36)/1000,z:parseInt(f[5],36)/1000,turn:Number(f[6]),parents:f[7]?f[7].split('-'):[]});
  }
  return instances;
}
function boothDecodeState(encoded) {
  if(typeof encoded!=='string'||encoded.length>8192)return null;
  if(encoded.startsWith('7~')) {
    const tokens=encoded.split('~'),floorIndex=Ae.length+3;
    if(tokens.length!==floorIndex+3||!/^[0-3]$/.test(tokens[2])||!/^[01]$/.test(tokens[floorIndex])||!/^(?:[1-9]\d{0,19})?$/.test(tokens[floorIndex+1]))return null;
    const layout=Ln.find(item=>item.id===tokens[1]);if(!layout)return null;
    const counts={};
    for(let j=0;j<Ae.length;j++) {
      if(!/^\d{1,2}$/.test(tokens[j+3])||Number(tokens[j+3])>Mi(Ae[j].id))return null;
      counts[Ae[j].id]=Number(tokens[j+3]);
    }
    const normal=boothNormaliseCounts(counts);
    if(Ae.some(item=>normal[item.id]!==counts[item.id]))return null;
    const state={layout,color:Object.keys(vn)[Number(tokens[2])],counts:normal,shape:'oval',floorEnabled:tokens[floorIndex]==='1',floorVariantId:tokens[floorIndex+1]};
    if(tokens[floorIndex+2]==='*')return state;
    const instances=boothParseRecords(tokens[floorIndex+2]);
    return boothValidateInstances(instances,normal)?{...state,instances}:null;
  }
  const positioned=encoded.startsWith('6~'),end=encoded.lastIndexOf('~');
  const old=boothDecodeLegacy(positioned?'5'+encoded.slice(1,end):encoded);if(!old)return null;
  if(!positioned)return {...old,legacyBridgeSides:{...old.counts},counts:boothNormaliseCounts(old.counts)};
  const instances=boothParseRecords(encoded.slice(end+1));
  if(!boothValidateInstances(instances,old.counts,true))return null;
  const ordinals={};
  for(const item of instances)if(boothSpec(item.id).group==='bridge') {
    item.ordinal=ordinals[item.id]||0;ordinals[item.id]=item.ordinal+1;item.side='';
  }
  const state={...old,counts:boothNormaliseCounts(old.counts),instances};
  return boothValidateInstances(instances,state.counts)?state:null;
}

function boothQuoteBridgePlacement(state,itemId=null) {
  return boothGroupItems('bridge').filter(item=>(!itemId||item.id===itemId)&&state.counts[item.id]).map(item=>item.short+' × '+state.counts[item.id]+'個').join(' ／ ');
}

const A=Ln,f=Ae,C=cr,w=vi,g=hr,O=yo,U=Mi,p=vn;
var v="homare-booth-quote:v1:",D=1440*60*1e3;function b(o){let a=new URL(o,location.origin);if(a.origin!==location.origin||!/^https?:$/.test(a.protocol)||a.username||a.password)throw new Error("\u540C\u3058\u30B9\u30C8\u30A2\u5185\u306E\u30DA\u30FC\u30B8\u3092\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002");return a}function x(encoded) { return boothDecodeState(encoded); }function m(o,a){return o===null?"\u672A\u78BA\u5B9A":new Intl.NumberFormat("ja-JP",{style:"currency",currency:a}).format(o/100)}function E(o){let a=x(o.state),t=["\u30D6\u30FC\u30B9\u898B\u7A4D\u3082\u308A\u4F9D\u983C\uFF08\u53C2\u8003\u4FA1\u683C\uFF09","\u69CB\u6210ID\uFF1A"+o.id,"\u78BA\u5B9A\u65E5\u6642\uFF1A"+new Date(o.createdAt).toLocaleString("ja-JP",{timeZone:"Asia/Tokyo"})+"\uFF08\u65E5\u672C\u6642\u9593\uFF09","\u5C0F\u9593\uFF1A"+a.layout.label+"\uFF0F\u9593\u53E3 "+a.layout.w+"m \xD7 \u5965\u884C "+a.layout.d+"m","\u88C5\u98FE\u30AB\u30E9\u30FC\uFF1A"+p[a.color].name,""];t.push(a.floorEnabled?"\u5E8A\u88C5\u98FE\uFF1A\u30D5\u30ED\u30EA\u30A2\uFF0F\u5E8A\u9762\u7A4D "+C(a.layout)+"\u33A1 \u2192 "+w(a.layout)+"\u5546\u54C1\uFF081\u33A1\u5358\u4F4D\u3067\u5207\u308A\u4E0A\u3052\uFF09":"\u5E8A\u88C5\u98FE\uFF1A\u306A\u3057","");if(a.counts.bridge||a.counts.bridge300)t.push("ブリッジ配置："+boothQuoteBridgePlacement(a),"");if(a.instances){t.push("配置座標：左奥原点／単位m／床面上、回転は垂直軸の角度");for(const item of a.instances)t.push(boothSpec(item.id).label+" #"+item.uid+"：x="+item.x.toFixed(3)+", z="+item.z.toFixed(3)+", 回転="+(item.turn*90)+"°"+(item.side?"、"+(item.side==="left"?"左側":"右側"):"")+(boothSpec(item.id).group==="bridge"?"、接続先="+(item.parents.length?item.parents.map(uid=>"#"+uid).join(","):"背面に未接続"):""));t.push("");}for(let s of o.rows)t.push(s.label+"\uFF1A"+s.productName,(s.variantName||"\u30D0\u30EA\u30A8\u30FC\u30B7\u30E7\u30F3\u672A\u78BA\u5B9A")+"\uFF0F\u6570\u91CF "+s.quantity,"\u5358\u4FA1 "+m(s.unit,o.currency)+"\uFF0F\u5C0F\u8A08 "+m(s.subtotal,o.currency)),s.status&&t.push("\u78BA\u8A8D\u4E8B\u9805\uFF1A"+s.status),s.productId&&t.push("\u5546\u54C1ID\uFF1A"+s.productId),s.variantId&&t.push("\u30D0\u30EA\u30A8\u30FC\u30B7\u30E7\u30F3ID\uFF1A"+s.variantId),s.url&&t.push(b(s.url).href),t.push("");return t.push("\u53C2\u8003\u5408\u8A08\uFF1A"+m(o.total,o.currency),o.taxNote,"\u901A\u8CA8\uFF1A"+o.currency,"\u6B63\u5F0F\u306A\u4FA1\u683C\u30FB\u9001\u6599\u30FB\u7D0D\u671F\u306F\u78BA\u8A8D\u5F8C\u306B\u3054\u6848\u5185\u3057\u307E\u3059\u3002"),o.fetchedAt&&t.push("\u5546\u54C1\u60C5\u5831\u53D6\u5F97\u65E5\u6642\uFF1A"+o.fetchedAt),o.warnings.length&&t.push("\u914D\u7F6E\u306E\u78BA\u8A8D\u4E8B\u9805\uFF1A"+o.warnings.join(" ")),t.push("","\u30D6\u30FC\u30B9\u518D\u8868\u793A\u30EA\u30F3\u30AF\uFF1A",o.replayURL,"\u203B\u518D\u8868\u793A\u6642\u306E\u5546\u54C1\u30FB\u30D0\u30EA\u30A8\u30FC\u30B7\u30E7\u30F3\u30FB\u4FA1\u683C\u306F\u3001\u305D\u306E\u6642\u70B9\u306E\u30C6\u30FC\u30DE\u8A2D\u5B9A\u304B\u3089\u53D6\u5F97\u3057\u307E\u3059\u3002\u4F9D\u983C\u6642\u306E\u5546\u54C1\u660E\u7D30\u306F\u4E0A\u8A18\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"),t.join(`
`)}function L(o){if(!/^[a-f0-9-]{36}$/.test(o||""))return null;try{let a=sessionStorage.getItem(v+o);if(!a||a.length>15e5)return null;let t=JSON.parse(a),s=x(t.state);if(t.version!==1||t.id!==o||!s||!Number.isFinite(t.createdAt)||Date.now()-t.createdAt>D||t.createdAt>Date.now()+6e4||!Array.isArray(t.rows)||t.rows.length<1||t.rows.length>g.length||!/^[A-Z]{3}$/.test(t.currency))return null;let i=O(s),d=e=>typeof e=="string"&&e.length<=4e3,u=e=>e===null||Number.isSafeInteger(e)&&e>=0&&e<1e15,c=new Set;for(let e of t.rows){if(!g.some(h=>h.id===e.id)||c.has(e.id)||!Number.isInteger(e.quantity)||e.quantity<1||e.quantity!==i[e.id]||![e.label,e.productName,e.variantName,e.status,e.url,e.productId,e.variantId].every(d)||!u(e.unit)||e.subtotal!==(e.unit===null?null:e.unit*e.quantity))return null;c.add(e.id),e.url&&b(e.url)}if(g.some(e=>i[e.id]>0&&!c.has(e.id))||s.floorEnabled&&s.floorVariantId&&t.rows.find(e=>e.id==="floorea")?.variantId!==s.floorVariantId)return null;let l=t.rows.some(e=>e.subtotal===null)?null:t.rows.reduce((e,h)=>e+h.subtotal,0);if(t.total!==l||!d(t.taxNote)||!Array.isArray(t.warnings)||t.warnings.length>10||!t.warnings.every(d))return null;let n=b(t.replayURL);return new URLSearchParams(n.hash.slice(1)).get("booth")!==t.state||typeof t.image!="string"||t.image&&!/^data:image\/jpeg;base64,[A-Za-z0-9+/=]+$/.test(t.image)?null:t}catch{return null}}var M=class extends HTMLElement{connectedCallback(){if(this._life)return;this._life=new AbortController;let a=this._life.signal,t=r=>this.querySelector(r),s=this.closest("form"),i=t("[data-quote-status]"),d=t("fieldset"),u=new URL(location.href).searchParams.get("booth_quote"),c=v+"return:"+location.pathname;if(this.dataset.formState==="success"){t("[data-quote-summary]").hidden=!0,t("[data-quote-form-body]").hidden=!0,i.hidden=!0;try{sessionStorage.removeItem(c)}catch{}return}let l=u;if(!l&&this.dataset.formState==="error")try{let r=JSON.parse(sessionStorage.getItem(c));r&&Date.now()-r.at<36e5&&(l=r.id)}catch{}let n=L(l);if(this._quote=n,!n){i.textContent=u||this.dataset.formState==="error"?"\u69CB\u6210\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u6709\u52B9\u671F\u9650\uFF0824\u6642\u9593\uFF09\u304C\u5207\u308C\u305F\u5834\u5408\u3084\u5225\u306E\u30BF\u30D6\u3067\u958B\u3044\u305F\u5834\u5408\u306F\u30013D\u30DA\u30FC\u30B8\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u9032\u307F\u304F\u3060\u3055\u3044\u3002":"3D\u30B7\u30DF\u30E5\u30EC\u30FC\u30BF\u30FC\u3067\u69CB\u6210\u3092\u9078\u3073\u3001\u300C\u3053\u306E\u5185\u5BB9\u3067\u898B\u7A4D\u3082\u308A\u3092\u4F9D\u983C\u3059\u308B\u300D\u304B\u3089\u304A\u9032\u307F\u304F\u3060\u3055\u3044\u3002";return}let e=x(n.state);i.hidden=!0,t("[data-quote-summary]").hidden=!1,t("[data-quote-form-body]").hidden=!1,t("[data-quote-layout]").textContent=e.layout.label+"\uFF08"+e.layout.w+"m \xD7 "+e.layout.d+"m\uFF09",t("[data-quote-color]").textContent=p[e.color].name,t("[data-quote-time]").textContent=new Date(n.createdAt).toLocaleString("ja-JP",{timeZone:"Asia/Tokyo"})+"\uFF08\u65E5\u672C\u6642\u9593\uFF09",t("[data-quote-id]").textContent=n.id;for(let r of this.querySelectorAll("[data-quote-edit]"))r.href=n.replayURL;if(n.image){let r=t("[data-quote-image]");r.src=n.image,r.hidden=!1}let h=t("[data-quote-lines]");h.replaceChildren();for(let r of n.rows){let S=document.createElement("li"),I=document.createElement("p"),N=document.createElement(r.url?"a":"strong"),z=document.createElement("p"),k=document.createElement("p");if(I.className="hbq-item-label",I.textContent=r.label,N.textContent=r.productName,r.url&&(N.href=b(r.url).href),z.textContent=r.variantName||r.status,z.className="hbq-note",k.className="hbq-calc",k.textContent=m(r.unit,n.currency)+" \xD7 "+r.quantity+"\u70B9 = "+m(r.subtotal,n.currency),S.append(I,N,z,k),r.status&&r.variantName){let q=document.createElement("p");q.className="hbq-warning",q.textContent=r.status,S.append(q)}if(r.id==="bridge"||r.id==="bridge300"){let placement=document.createElement("p");placement.className="hbq-note";placement.textContent="配置："+boothQuoteBridgePlacement(e,r.id);S.append(placement)}h.append(S)}if(e.instances){t("[data-placement-details]")?.remove();const details=document.createElement("details"),summary=document.createElement("summary"),list=document.createElement("ul");details.className="hbq-meta";details.dataset.placementDetails="";summary.textContent="アイテムの位置・向き・接続";for(const item of e.instances){const row=document.createElement("li");row.textContent=boothSpec(item.id).label+" #"+item.uid+"：左から"+item.x.toFixed(3)+"m／奥から"+item.z.toFixed(3)+"m／"+item.turn*90+"°"+(boothSpec(item.id).group==="bridge"?"／接続先 "+(item.parents.join(", ")||"背面に未接続"):"");list.append(row);}details.append(summary,list);t("[data-quote-summary]").append(details);}t("[data-quote-total]").textContent=m(n.total,n.currency),t("[data-quote-tax]").textContent=n.taxNote;let y=[...n.warnings];n.total===null&&y.unshift("\u4FA1\u683C\u3092\u78BA\u8A8D\u3067\u304D\u3066\u3044\u306A\u3044\u5546\u54C1\u304C\u3042\u308A\u307E\u3059\u3002\u91D1\u984D\u306F\u62C5\u5F53\u8005\u304C\u78BA\u8A8D\u3057\u3066\u3054\u6848\u5185\u3057\u307E\u3059\u3002"),t("[data-quote-warnings]").textContent=y.join(" "),t("[data-quote-warnings]").hidden=!y.length,t("[data-quote-payload]").value=E(n),d.disabled=!1,s.addEventListener("submit",r=>{if(!L(n.id)){r.preventDefault(),i.hidden=!1,i.textContent="\u69CB\u6210\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u307E\u3057\u305F\u30023D\u30DA\u30FC\u30B8\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u9032\u307F\u304F\u3060\u3055\u3044\u3002",i.scrollIntoView({block:"center"}),d.disabled=!0;return}t("[data-quote-payload]").value=E(n);try{sessionStorage.setItem(c,JSON.stringify({id:n.id,at:Date.now()}))}catch{}},{signal:a})}disconnectedCallback(){queueMicrotask(()=>{this.isConnected||(this._life?.abort(),this._life=null,this._quote=null)})}};customElements.get("homare-booth-quote")||customElements.define("homare-booth-quote",M);})();
